<template>
  <r-panel :disabled="disabled" :title="title">

    <template v-slot:header>
      <v-switch
          v-model="value.enabled"
          label="Enabled"
          color="success"
          class="mt-0 mr-5"
          @click.native.stop
          hide-details
      />
    </template>
    <v-row dense>
      <v-col cols="12" md="3" sm="3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model.number="value.duration"
                          v-on="on"
                          v-bind="attrs"
                          label="Feature Duration"
                          hide-details/>
          </template>
          <dt>Lower Cap feature duration</dt>
          <dt>0 - UNLIMITED</dt>
        </v-tooltip>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model.number="value.collectDataDuration"
                          v-on="on"
                          v-bind="attrs"
                          label="Collect Data Duration"
                          hide-details/>
          </template>
          <dt>Amount of seconds that the feature will collect data before assign a segment</dt>
        </v-tooltip>
      </v-col>
      <v-col cols="12" sm="3" md="3">
        <r-range :model.sync="value.sinkCount" label="Sink Count" labelFrom="Min Value" labelTo="Max Value" hide-details/>
      </v-col>
      <v-col cols="12" sm="3" md="3">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model.number="value.sinkPrice"
                          v-on="on"
                          v-bind="attrs"
                          label="Sink Price"
                          hide-details/>
          </template>
          <dt>The maximum price a player pays to continue playing in PTHs that allow them to join a lower-cap segment</dt>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row dense class="mt-8">
      <v-col cols="12" sm="12" md="12">
        <r-currency-table :items.sync="value.defaultPrice" title="Default Price"/>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <r-currency-table :items.sync="value.lowerPrice" title="Lower Price"/>
      </v-col>
    </v-row>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {TreasureLowerCapConfig} from "@/modules/redactor/models/smart-offer/bundle-treasure/TreasureLowerCapConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RRange from "@/modules/redactor/views/utils/r-range.vue";
import RCurrencyTable from "@/modules/redactor/views/currency/r-currency-table.vue";

export default {
  name: "r-treasure-lower-cap-config-panel",
  components: {RCurrencyTable, RRange, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Lower Cap"),
    model: VueTypes.instanceOf(TreasureLowerCapConfig)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new TreasureLowerCapConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}
</script>
